import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  HStack,
  Center,
  Text,
  Image,
  ChakraProvider,
  Button,
} from "@chakra-ui/react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import modalTheme from "./modalTheme";
import {
  getPopupImage,
  getPopupMessage,
  getPopupTitle,
} from "../../../../utils/wall/wall-message-bank";
import { useWall } from "../../../../context/WallContext";
import Lottie from "react-lottie-player";
import { getEmotionalMessageText } from "../../../../utils/common-utils";
import useStateRef from "react-usestateref";
import { StorageService } from "../../../../utils/StorageUtils";

export default function PopupModal({
  isOpen = false,
  handleClose,
  type,
  isShareActivity,
  handleProceed,
  handleCancel,
  proceedTxt = "Yes",
  cancelTxt = "No",
  remainder,
  count,
  userName,
  isLoading = false,
  uploadConfirmed = false,
}) {
  const { messageBank } = useWall();
  const [message, setMessage] = useState("");
  const [shouldAutoClose, setShouldAutoClose] = useState(false);
  const [userDetails, setUserDetails, userDetailsRef] = useStateRef({});

  useEffect(() => {
    let closeTimer;

    if (isOpen && isLoading) {
      closeTimer = setTimeout(() => {
        setShouldAutoClose(true);
        if (uploadConfirmed) {
          handleClose && handleClose();
        }
      }, 7000);
    }

    return () => {
      clearTimeout(closeTimer);
    };
  }, [isOpen, isLoading]);

  useEffect(() => {
    if (uploadConfirmed && shouldAutoClose) {
      handleClose && handleClose();
    }
  }, [uploadConfirmed, shouldAutoClose]);

  useEffect(() => {
    let details = StorageService.getItem("user_additional_details");
    details = typeof details === "object" ? details : JSON.parse(details);
    if (details) {
      setUserDetails(details);
    }
    fetchMessage();
  }, []);
  const fetchMessage = async () => {
    let response;
    if (type === "upload") {
      response = await getEmotionalMessageText(21);
      if (
        response.includes("@@studentName") ||
        response.includes("@@studentname")
      ) {
        response = response.replace(
          /@@studentName|@@studentname/g,
          `${userDetailsRef.current?.firstName}`
        );
      }
    } else {
      response = await getPopupMessage(
        type,
        isShareActivity,
        messageBank,
        count,
        (userName = "User")
      );
    }
    setMessage(response || "");
  };

  return (
    <ChakraProvider theme={modalTheme}>
      <Modal isOpen={isOpen} size="xl">
        <ModalOverlay />
        <ModalContent
          w="724px"
          maxH="550px"
          borderRadius={"8px"}
          sx={{ bgColor: "white" }}
        >
          <ModalBody padding={"16px"} position={"relative"}>
            {type !== "upload" && <CloseButton handleClose={handleClose} />}
            <Center
              w={"100%"}
              height={"100%"}
              flexDirection={"column"}
              gap={"8px"}
              mt={"32px"}
            >
              <Text variant={"missionTitle"}>{getPopupTitle(type)}</Text>
              {type === "Delete post" ? (
                <Lottie
                  animationData={getPopupImage(type)}
                  play
                  loop={false}
                  style={{
                    width: "20%",
                    height: "20%",
                  }}
                />
              ) : type === "upload" ? (
                <Lottie
                  animationData={getPopupImage(type)}
                  play
                  loop
                  style={{
                    width: "20%",
                    height: "20%",
                  }}
                />
              ) : (
                <Image src={getPopupImage(type)} />
              )}

              {remainder && (
                <Text variant={"missionDescription"} color={"#6082C2"}>
                  {remainder}
                </Text>
              )}
              <Text
                variant={"missionDescription"}
                my={type === "upload" && "24px"}
              >
                {message?.replace(/@@poststudentname/g, userName)}
              </Text>
              {handleProceed && handleCancel && (
                <Buttons
                  handleProceed={handleProceed}
                  handleCancel={handleCancel}
                  proceedTxt={proceedTxt}
                  cancelTxt={cancelTxt}
                />
              )}
            </Center>
          </ModalBody>
        </ModalContent>
      </Modal>
    </ChakraProvider>
  );
}

const CloseButton = ({ handleClose }) => {
  return (
    <React.Fragment>
      {handleClose && (
        <HStack
          position={"absolute"}
          cursor={"pointer"}
          right={"32px"}
          onClick={() => {
            handleClose && handleClose();
          }}
        >
          <IoIosCloseCircleOutline size={"32px"} color="#AAB3B8" />
        </HStack>
      )}
    </React.Fragment>
  );
};

const Buttons = ({ handleProceed, handleCancel, proceedTxt, cancelTxt }) => {
  return (
    <HStack spacing={4} mt={4}>
      {handleProceed && (
        <CustomButton
          variant="solid"
          label={proceedTxt}
          sx={{
            bg: "#7464CE",
            color: "white",
            _hover: {
              bg: "#5a4db8",
              color: "white",
            },
          }}
          onClick={handleProceed}
        />
      )}
      {handleCancel && (
        <CustomButton
          variant="outline"
          label={cancelTxt}
          sx={{
            borderColor: "#7464CE",
            color: "#7464CE",
            _hover: {
              bg: "white",
            },
          }}
          onClick={handleCancel}
        />
      )}
    </HStack>
  );
};

const CustomButton = ({ label, variant, sx, onClick }) => {
  return (
    <Button
      w={"200px"}
      h={"40px"}
      variant={variant}
      borderRadius={"8px"}
      sx={sx}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};
